import { useLocation } from 'react-router-dom';

/**
 * Sample-data previews for layout work: `?demo=activity`, `?demo=enablement`, a comma list, or `?demo=all`.
 * Never on a production build.
 */
export function useDemoFlag(name: string): boolean {
  const { search } = useLocation();
  if (process.env.NODE_ENV === 'production') return false;
  const flags = (new URLSearchParams(search).get('demo') || '').split(',').map((s) => s.trim());
  return flags.includes(name) || flags.includes('all');
}
